// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
require("@rails/ujs").start()
require("turbolinks").start()
// we don't use animated progress
Turbolinks.ProgressBar.prototype.refresh = function() {}
// custom css
Turbolinks.ProgressBar.defaultCSS = ""
// creates progress bar with custom markup
Turbolinks.ProgressBar.prototype.installProgressElement = function() {
  $(".child-loader").show();
}

// removes progress bar with custom markup
Turbolinks.ProgressBar.prototype.uninstallProgressElement = function() {
  $(".child-loader").hide();
}
// changes the default 500ms threshold to show progress bar
Turbolinks.BrowserAdapter.prototype.showProgressBarAfterDelay = function() {
  return this.progressBarTimeout = setTimeout(this.showProgressBar, 50);
};
require("@rails/activestorage").start()
require("channels")
require("jquery")
//require("packs/prototype")
require("packs/filterrific-jquery")
require("micromodal/dist/micromodal")
require("./micromodal.js")
require("./prototype.js")
require("./utils.js")
require("./x-editable.js")
require('select2')
require("frappe-gantt")
require("@fancyapps/ui/dist/fancybox")
require("tinymce")
//require("packs/loader")
//require("./stylesheets_login.scss");
//require("./stylesheets_v1.scss");
// require("packs/controls") 

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
 const images = require.context('../images', true)
 const imagePath = (name) => images(name, true)
//require("bootstrap")
//require('popper.js')

/*
//TUI CALENDAR
require('tui-calendar'); 
require("tui-calendar/dist/tui-calendar.css");
// If you use the default popups, use this.
require ('tui-time-picker/dist/tui-time-picker.css');
require ('tui-date-picker/dist/tui-date-picker.css');
require ("tui-time-picker/dist/tui-time-picker.js");  
require ("tui-date-picker/dist/tui-date-picker.js");  
//////////////////////
*/

//Flatpickr for dates 
require("flatpickr")
require("flatpickr/dist/themes/dark.css");
require("shortcut-buttons-flatpickr");
require("intl-tel-input");
import  { Fancybox }   from "@fancyapps/ui/src/Fancybox";
import ShortcutButtonsFlatpickr from "shortcut-buttons-flatpickr"
import flatpickr from "flatpickr";
import "flatpickr/dist/l10n/fr.js";

//CROPPER UPLOADER
import "./custom_cropper.js";
require("cropperjs/dist/cropper.css");



// import intlTelInput from 'intl-tel-input';


// const input = document.querySelector("#phone");

// intlTelInput(input, {
//     customPlaceholder: function(selectedCountryPlaceholder, selectedCountryData) {
//       return "e.g. " + selectedCountryPlaceholder;
//     },
//   });

document.addEventListener("turbolinks:load", () => {
    Fancybox.bind("[data-fancybox]",Fancybox.defaults);
    flatpickr("[class='flatpickr']", {
        "locale": "fr",
        "dateFormat": "d/m/Y",
        plugins: [
            ShortcutButtonsFlatpickr({
                button: {
                    label: 'Effacer',
                },
                onClick: (index, fp) => {
                    fp.clear();
                    fp.close();
                }
             })
        ]
    })
})
//$.fn.editable.defaults.mode = 'inline';
//$.fn.editableform.buttons = '<button type="submit" class="editable-submit" style="border: none;cursor: pointer;outline: inherit;box-sizing: border-box;width: 32px;z-index: 200;background-color: var(--ds-surface-overlay, #FFFFFF);border-radius: 3px;font-size: 14px;box-shadow: var(--ds-shadow-overlay, 0 4px 8px -2px rgba(9, 30, 66, 0.25), 0 0 1px rgba(9, 30, 66, 0.31));"><i class="far fa-save" style="font-size: 16px;color:green" ></i>'
//import 'tui-calendar'

import "controllers"
import 'select2'; // globally assign select2 fn to $ element
import 'select2/dist/css/select2.css';
import "@fancyapps/ui/dist/fancybox.css";
import 'frappe-gantt/dist/frappe-gantt.css'
import "@fortawesome/fontawesome-free/css/all"

//Safari reflex
const originalWebSocketClose = WebSocket.prototype.close
WebSocket.prototype.close = function () {
  if (this.readyState != WebSocket.CONNECTING) {
    originalWebSocketClose.apply(this, arguments)
  }
}